<template>
    <div class="agency-block" :class="[{'agency-block--verified': offerData.verified}, 'agency-block--status-' + offerData.status]">
        <div class="agency-block__header">
            <div class="agency-block__header__name">
                <span v-text="translations.title"></span>
                <h2 v-text="offerData.tourOperator"></h2>
            </div>
            <transition name="fade-transition">
                <div class="agency-block__header__logo" v-if="offerData.img">
                    <img :src="offerData.img" :alt="offerData.tourOperator">
                </div>
            </transition>
        </div>
        <div class="travel-block-grid">
            <travel-block :title="translations.travel_out"  :flight-data="offerData.outboundFlight"></travel-block>
            <travel-block :title="translations.travel_home" :flight-data="offerData.inboundFlight"></travel-block>
        </div>
        <p class="agency-block__travel-disclaimer" v-text="translations.notice"></p>
        <div class="agency-block__priced-included-wrapper">
            <div class="included-item-grid">
                <included-item v-if="offerData.transferInlcuded" :title="translations.includes.transfer_included" icon-type="transfer"></included-item>
                <included-item v-if="!offerData.transferInlcuded"  :title="translations.includes.transfer_not_included" icon-type="transfer"></included-item>
                <included-item :title="translations.includes.loggage_included" icon-type="baggage"></included-item>
                <included-item :title="offerData.originalRoomName" :translatedTitle="offerData.translatedRoomName" :room-images="hasRoomImages" icon-type="hotel" @showroomimages="onShowRoomImages"></included-item>
                <included-item :title="offerData.boardType" icon-type="food"></included-item>
                <included-item :title="translations.includes.flight_class" icon-type="flightclass"></included-item>
                <included-item v-if="offerData.handicap" :title="translations.includes.handicap" icon-type="handicap"></included-item>
                <included-item v-if="!offerData.handicap" :title="translations.includes.not_handicap" icon-type="noHandicap"></included-item>
            </div>
            <total-price :totalPrice="offerData.totalPrice.value" :currency="offerData.totalPrice.currency" :show-from="false"></total-price>
        </div>
        <div class="agency-block__actions">
            <button class="btn btn--travel-description" @click="getDescription">
                <span class="btn__icon btn__icon--left">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 435.2 405.04"><path d="M115.14,0H319.9c63.34,0,115.3,50.72,115.3,112.83v94.09C435.2,269,383.24,320,319.9,320H259.11l-97.75,81.47c-4.23,3.77-19.92,4.6-25.09,2.28A13.83,13.83,0,0,1,128,390.87V320H115.14C51.79,320,0,269,0,206.92V112.83C0,50.72,51.79,0,115.14,0Z"/></svg>
                </span>
                <span class="btn__text" v-text="translations.travel_description"></span>
            </button>
            <button :disabled="!offerCanBeBooked" @click="gotoBooking" class="btn btn--positive" :class="{'loading': loadingBooking}">
                <span class="btn__icon btn__icon--left">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 28.08 28.08"><path d="M21.22,2.62l-3,3L3.54,3.33,0,6.86l13,4L7.78,16.06H2.12L0,18.18,7.78,20.3,9.9,28.08,12,26V20.3l5.24-5.23,4,13,3.53-3.53L22.49,9.83l3-3C27.8,4.53,28.75,1.67,27.58.5S23.55.29,21.22,2.62Z"/></svg>
                </span>
                <span class="btn__text" v-text="translations.order_btn"></span>
                <span class="btn__icon btn__icon--right">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 27.01 26.01"><path d="M26.13,10.88l-10-10a3,3,0,1,0-4.25,4.24L16.76,10H3a3,3,0,0,0,0,6H16.76l-4.88,4.88a3,3,0,0,0,4.25,4.25l10-10A3,3,0,0,0,27,13,3,3,0,0,0,26.13,10.88Z"/></svg>
                </span>
            </button>
        </div>
        <modal v-if="openModal" @close="openModal = false" :close-on-click="true" :is-open="openModal" class="modal-view--bg modal-view--tour-description" :title="translations.description_title">
            <svg slot="icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 435.2 405.04"><path d="M115.14,0H319.9c63.34,0,115.3,50.72,115.3,112.83v94.09C435.2,269,383.24,320,319.9,320H259.11l-97.75,81.47c-4.23,3.77-19.92,4.6-25.09,2.28A13.83,13.83,0,0,1,128,390.87V320H115.14C51.79,320,0,269,0,206.92V112.83C0,50.72,51.79,0,115.14,0Z"/></svg>
            <div class="tour-description" :class="{'loading': loadingDescription}">
                <transition name="fade-transition">
                    <div class="tour-description__content" v-if="loadingDescription == false">
                        <div class="msg-block msg-block--info" v-if="!description">
                            <p><b v-text="translations.ERRORS.NO_DESCRIPTION_HEADER"></b> {{ translations.ERRORS.NO_DESCRIPTION_BODY }}</p>
                        </div>
                        <div class="msg-block msg-block--flex msg-block--info" v-if="description">
                            <div class="msg-block__text">
                                <p><b v-text="(!orginalLanguage) ? translations.translations_info_header : translations.translations_info_header_original"></b></p>
                                <p>{{ translations.translations_info_text }} <a href="javascript:void(0)" v-text="(!orginalLanguage) ? translations.translations_info_link : translations.translations_info_link_original" @click="orginalLanguage = !orginalLanguage"></a></p>
                            </div>
                            <div class="msg-block__action">
                                <a href="javascript:void(0)" class="translate-btn" @click="orginalLanguage = !orginalLanguage" :title="(!orginalLanguage) ? translations.translations_info_link : translations.translations_info_link_original">
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path d="m22.69,7.51l-2.33-1.17-.67,1.35,5.51,2.76.59-5.62-1.5-.16-.23,2.21c-1.62-3.09-4.46-5.41-7.87-6.35l-.4,1.45c2.98.82,5.47,2.83,6.9,5.52Z"/><path d="m8.83,25.09l1.36.97.87-1.22-4.51-3.22-.69,5.89,1.49.17.21-1.78c1.74,3.02,4.66,5.24,8.09,6.09l.36-1.46c-3.06-.76-5.65-2.74-7.18-5.44Z"/><path d="m27.71,27.85l.28-1.48c-1.87-.36-3.42-.99-4.65-1.88.56-.59.98-1.19,1.29-1.75.71-1.25.98-2.42,1.09-3.15h2.13v-1.5h-4.89v-2.09h-1.5v2.09h-4.89v1.5h2.13c.11.73.38,1.9,1.09,3.15.31.55.73,1.15,1.29,1.75-1.23.9-2.79,1.53-4.65,1.88l.28,1.48c2.44-.47,4.22-1.34,5.5-2.34,1.28.99,3.06,1.87,5.5,2.34Zm-3.52-8.25c-.11.61-.36,1.51-.91,2.47-.3.52-.66,1-1.07,1.44-.41-.44-.77-.91-1.07-1.44-.55-.95-.8-1.86-.91-2.47h3.96Z"/><path d="m8.14,4.42l-3.93,11.12h1.82l1.11-3.13h4.15l1.15,3.13h1.93l-4.1-11.12h-2.15Zm2.69,6.42h-3.21l.2-.59c.6-1.78,1.09-3.23,1.36-4.13.23.74.64,1.88,1.26,3.61.12.34.25.71.39,1.1Z"/><path d="m12.73,18.46H2.56c-.33,0-.61-.27-.61-.61V2.11c0-.33.27-.61.61-.61h10.18V0H2.56C1.39,0,.44.95.44,2.11v15.74c0,1.16.95,2.11,2.11,2.11h10.18v-1.5Z"/><path d="m29.44,12.01h-10.18v1.5h10.18c.33,0,.61.27.61.61v15.74c0,.33-.27.61-.61.61h-10.18v1.5h10.18c1.16,0,2.11-.95,2.11-2.11v-15.74c0-1.16-.95-2.11-2.11-2.11Z"/></svg>
                                </a>
                            </div>
                        </div>
                        <div v-if="description" v-html="description" class="tour-description__content__text"></div>
                        <div class="msg-block msg-block--flex msg-block--info" v-if="description">
                            <div class="msg-block__text">
                                <p><b v-text="(!orginalLanguage) ? translations.translations_info_header : translations.translations_info_header_original"></b></p>
                                <p>{{ translations.translations_info_text }} <a href="javascript:void(0)" v-text="(!orginalLanguage) ? translations.translations_info_link : translations.translations_info_link_original" @click="orginalLanguage = !orginalLanguage"></a></p>
                            </div>
                            <div class="msg-block__action">
                                <a href="javascript:void(0)" class="translate-btn" @click="orginalLanguage = !orginalLanguage" :title="(!orginalLanguage) ? translations.translations_info_link : translations.translations_info_link_original">
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path d="m22.69,7.51l-2.33-1.17-.67,1.35,5.51,2.76.59-5.62-1.5-.16-.23,2.21c-1.62-3.09-4.46-5.41-7.87-6.35l-.4,1.45c2.98.82,5.47,2.83,6.9,5.52Z"/><path d="m8.83,25.09l1.36.97.87-1.22-4.51-3.22-.69,5.89,1.49.17.21-1.78c1.74,3.02,4.66,5.24,8.09,6.09l.36-1.46c-3.06-.76-5.65-2.74-7.18-5.44Z"/><path d="m27.71,27.85l.28-1.48c-1.87-.36-3.42-.99-4.65-1.88.56-.59.98-1.19,1.29-1.75.71-1.25.98-2.42,1.09-3.15h2.13v-1.5h-4.89v-2.09h-1.5v2.09h-4.89v1.5h2.13c.11.73.38,1.9,1.09,3.15.31.55.73,1.15,1.29,1.75-1.23.9-2.79,1.53-4.65,1.88l.28,1.48c2.44-.47,4.22-1.34,5.5-2.34,1.28.99,3.06,1.87,5.5,2.34Zm-3.52-8.25c-.11.61-.36,1.51-.91,2.47-.3.52-.66,1-1.07,1.44-.41-.44-.77-.91-1.07-1.44-.55-.95-.8-1.86-.91-2.47h3.96Z"/><path d="m8.14,4.42l-3.93,11.12h1.82l1.11-3.13h4.15l1.15,3.13h1.93l-4.1-11.12h-2.15Zm2.69,6.42h-3.21l.2-.59c.6-1.78,1.09-3.23,1.36-4.13.23.74.64,1.88,1.26,3.61.12.34.25.71.39,1.1Z"/><path d="m12.73,18.46H2.56c-.33,0-.61-.27-.61-.61V2.11c0-.33.27-.61.61-.61h10.18V0H2.56C1.39,0,.44.95.44,2.11v15.74c0,1.16.95,2.11,2.11,2.11h10.18v-1.5Z"/><path d="m29.44,12.01h-10.18v1.5h10.18c.33,0,.61.27.61.61v15.74c0,.33-.27.61-.61.61h-10.18v1.5h10.18c1.16,0,2.11-.95,2.11-2.11v-15.74c0-1.16-.95-2.11-2.11-2.11Z"/></svg>
                                </a>
                            </div>
                        </div>
                    </div>
                </transition>
            </div>
        </modal>
        <div class="msg-block msg-block--error" v-if="bookingError">
            <p><b v-text="bookingError"></b></p>
        </div>
         <div class="msg-block msg-block--info msg-block-XX" v-if="offerData.status === 'XX'">
            <p><b v-text="translations.ERRORS.BO_STATUS.title"></b></p>
            <p v-text="translations.ERRORS.BO_STATUS.text"></p>
        </div>
        <div class="msg-block msg-block--error msg-block-NK" v-if="offerData.status === 'NK' || offerData.status === 'FAIL'">
            <p><b v-text="translations.ERRORS.NK_STATUS.title"></b></p>
            <p v-text="translations.ERRORS.NK_STATUS.text"></p>
        </div>
        <div class="msg-block msg-block--warning msg-block-RQ" v-if="offerData.status === 'RQ'">
            <p><b v-text="translations.ERRORS.RQ_STATUS.title"></b></p>
            <p v-text="translations.ERRORS.RQ_STATUS.text"></p>
        </div>
        <div class="msg-block msg-block--warning msg-block-FLIGHT_CHANGE" v-if="offerData.status === 'FLIGHT_CHANGE'">
            <p><b v-text="translations.ERRORS.FLIGHT_CHANGE"></b></p>
        </div>
        <div class="msg-block msg-block--warning msg-block-PRICE_CHANGE" v-if="offerData.status === 'PRICE_CHANGE'">
            <p><b v-text="translations.ERRORS.PRICE_CHANGE"></b></p>
        </div>
    </div>
</template>

<script type="text/javascript">
    import TotalPrice from './total-price.vue';
    import TravelBlock from './travel-block.vue';
    import IncludedItem from './included-item.vue';
    import Modal from './modal.vue';
    import API from '../skovapi.js';
    import _ from 'underscore';
    import SkovApi from '../skovapi.js';
    import { trackEvent } from '../tracker';

    export default {
        props: {
            offer: {type: Object, default: null},
            bookingLoading: {type: Boolean, default: false},
            availbleRoomImageCodes: {type: Array, default() {return [ ]}}
        },
        data() {
            return {
                translations: APP_CONFIG.TRANSLATION.AGENCY_BLOCK,  
                themePath: APP_CONFIG.THEME_PATH,
                showDescription: false,
                loadingDescription: false,
                openModal: false,
                description: null,
                orginalLanguage: false,
                loadingBooking: false,
                bookingError: null,
                statusOverwrite: null
            }
        },
        watch: {
            showDescription() {
                setTimeout(() => {
                    this.openModal = this.showDescription;
                }, 250);
            },
            orginalLanguage() {
                this.description = null;
                this.getDescription();
            },
            loadingBooking() {
                this.$emit('loadingbooking', this.loadingBooking);
            }
        },
        methods: {
            onShowRoomImages() {
                this.$emit('showRoomImages', this.roomType.code);
            },
            gotoBooking() {
                this.bookingError = null;
                if(this.loadingBooking || !this.offerCanBeBooked)
                    return;
           
                let offer = Object.assign({}, this.offer);
                let query = _.pick(this.$route.query, ['adults', 'children', 'directFlight']);

                if(typeof query.children === 'string') {
                    query.children = JSON.parse(query.children);
                }

                this.loadingBooking = true;
                SkovApi.makeBookingDraft({
                    offerCode: this.offer.code,
                    destinationId: this.$store.state.destination.id,
                    totalPriceEuro: this.offer.totalPriceEuro,
                    personPriceEuro: this.offer.personPriceEuro
                }).then(({data}) => {
                    this.$store.dispatch('loadBookingDraft', data.bookingDraftId).then(() => {
                        if(!this.checkValidStatus(this.$store.state.selectedBookingOffer.verifiedOffer.status)) {
                            this.statusOverwrite = this.$store.state.selectedBookingOffer.verifiedOffer.status;
                            this.loadingBooking = false;
                            return;
                        }
                        
                        this.$store.commit('selectedAgencyOffer', offer);
                        this.$router.push({
                            path: '/booking/' + data.bookingDraftId
                        }, (to) => {
                            trackEvent({
                                event: 'CTA Klik - Gå til bestilling',
                                target: to.fullPath,
                                action: this.hotelName,
                                destination: (this.$store) ? this.$store.state.destination : null,
                                value: (this.offerData.totalPrice) ? this.offerData.totalPrice.value : null,
                                'interaction-type': 'noninteraction',
                            })
                        })
                    }).catch((error) => {
                        console.error(error);
                        this.loadingBooking = false;
                        this.bookingError = this.translations.ERRORS.draft_error;
                    });
                }).catch((error) => {
                     if(error.response && error.response.status == 406) {
                        this.statusOverwrite = error.response.data.status;
                        this.loadingBooking = false;
                    } else {
                        console.error(error);
                        this.loadingBooking = false;
                        this.bookingError = this.translations.ERRORS.draft_error;
                    }
                })
            },
            getDescription() {
                if(this.loadingDescription)
                    return;
                
                this.openModal = true;
                trackEvent({
                    event: 'CTA Klik - Rejsebeskrivelse fra rejsebureauet',
                    action: this.hotelName,
                    destination: (this.$store) ? this.$store.state.destination : null,
                    'interaction-type': 'noninteraction'
                });

                if(this.description) {
                    return;
                }

                this.loadingDescription = true;
                let lang = (this.orginalLanguage) ? 'de' : 'da';
                API.getTourOperatorDescription(this.offerData.hotelId, this.offerData.tourOperatorCode, lang).then((res) => {
                    this.loadingDescription = false;
                    this.description = res.data.description;
                }).catch((error) => {
                    this.loadingDescription = false;
                    this.description = null;
                });
            },
            tourOperatorImage(tourOperator) {
                let img = 'default.svg';

                if(tourOperator && tourOperator.code) {
                    switch(tourOperator.code) {
                        case "TUI":
                            img = 'logo-tui.svg';
                            break;
                        case "XFTI":
                            img = 'logo-white-ferientouristik.png';
                            break;
                        case "FTI":
                            img = 'logo-white-fti.svg';
                            break;
                        default:
                            if(tourOperator.logo) {
                                return tourOperator.logo;
                            }

                            img = 'default.svg';
                            break;
                    }
                }

                return this.themePath + '/assets/img/logos/' + img;
            },
            checkValidStatus(status) {
                return ['OK', 'RQ', 'FLIGHT_CHANGE', 'PRICE_CHANGE'].indexOf(status) > -1 ? true : false;
            }
        },
        computed: {
            hasOfferCode() {
                return (this.offer && this.offer.code) ? true : false;
            },
            hasRoomImages() {
                if(this.roomType.code) {
                    return this.availbleRoomImageCodes.filter((code) => code === this.roomType.code).length ? true : false;
                }

                return false;
            },
            roomType() {
                if(this.offer && this.offer.hotelOffer && this.offer.hotelOffer.roomType && this.offer.hotelOffer.roomType) {
                    return this.offer.hotelOffer.roomType;
                }

                return {};
            },
            validStatus() {
                let status = (this.offerData.status) ? this.offerData.status : '';
                return this.checkValidStatus(status)
            },
            offerCanBeBooked() {
                return (
                    this.hasOfferCode && 
                    this.offerData.verified && 
                    !(this.bookingLoading && !this.loadingBooking) &&
                    this.validStatus
                ) ? true : false
            },
            hotelName() {
                return (this.offer && this.offer.hotelOffer && this.offer.hotelOffer.hotel) ? this.offer.hotelOffer.hotel.name : '';
            },
            offerData() {
                if(!this.offer) {
                    return { }
                }

                let originalRoomName = [ this.offer.hotelOffer.roomType.name];
                if(this.offer.hotelOffer.roomType.additionalRoomName) {
                    originalRoomName.push(this.offer.hotelOffer.roomType.additionalRoomName);
                }

                let translatedRoomName = [ ];
                if(this.offer.hotelOffer.roomType.translatedAdditionalRoomName) {
                    translatedRoomName.push(this.offer.hotelOffer.roomType.name);
                    translatedRoomName.push(this.offer.hotelOffer.roomType.translatedAdditionalRoomName);
                }
                
                return {
                    hotelId: this.offer.hotelOffer.hotel.id,
                    tourOperatorCode: this.offer.tourOperator.code,
                    tourOperator: this.offer.tourOperator.name || '',
                    img: this.tourOperatorImage(this.offer.tourOperator),
                    transferInlcuded: (this.offer.transferIncluded === true) ? true : false,
                    originalRoomName,
                    translatedRoomName,
                    boardType: this.offer.hotelOffer.boardType.name,
                    totalPrice: (!this.checkValidStatus(this.offer.status) && this.offer.originalTotalPrice) ? this.offer.originalTotalPrice : this.offer.totalPrice,
                    verified: (this.offer.status) ? true : false,
                    status: (this.statusOverwrite) ? this.statusOverwrite : this.offer.status,
                    handicap: (this.offer.bookingInformation) ? this.offer.bookingInformation.accommodatesDisabledGuests : false,
                    hasFlightOffer: (this.offer.flightOffer) ? true : false,
                    inboundFlight: {
                        estimatedTime: (this.offer.flightOffer) ? this.offer.flightOffer.flight.inboundEstimatedTravelTime : null,
                        legList: (this.offer.flightOffer) ? this.offer.flightOffer.flight.inboundLegList : null
                    },
                    outboundFlight: {
                        estimatedTime: (this.offer.flightOffer) ? this.offer.flightOffer.flight.outboundEstimatedTravelTime : null,
                        legList: (this.offer.flightOffer) ? this.offer.flightOffer.flight.outboundLegList : null
                    }
                }
            }
        },
        components: {
            'total-price': TotalPrice,
            'travel-block': TravelBlock,
            'included-item': IncludedItem,
            Modal
        }
    }
</script>